import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Wallet, ArrowRight } from 'lucide-react';
import { AUTH } from '@/constants/testIds';
import { formatApiErrorDetail } from '@/lib/api';

export default function RegisterPage() {
  const nav = useNavigate();
  const { registerCompany } = useAuth();
  const [form, setForm] = useState({
    company_name: '', company_document: '',
    admin_name: '', admin_email: '', admin_password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await registerCompany(form);
      nav('/dashboard', { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-6">
      <div className="w-full max-w-lg">
        <Link to="/login" className="inline-flex items-center gap-2 mb-8">
          <div className="h-9 w-9 rounded-lg bg-emerald-500 grid place-items-center"><Wallet className="h-5 w-5 text-white" /></div>
          <span className="font-heading font-semibold text-lg">Ledgerly</span>
        </Link>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Criar sua empresa</h1>
        <p className="text-muted-foreground text-sm mt-2 mb-6">Você será o primeiro administrador. Poderá adicionar sua equipe depois.</p>

        <form onSubmit={submit} data-testid={AUTH.registerForm} className="space-y-4 bg-card border rounded-xl p-6">
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2 space-y-2">
              <Label>Nome da empresa</Label>
              <Input data-testid={AUTH.registerCompany} required value={form.company_name} onChange={set('company_name')} placeholder="Minha Empresa LTDA" />
            </div>
            <div className="col-span-2 space-y-2">
              <Label>CNPJ (opcional)</Label>
              <Input data-testid={AUTH.registerDocument} value={form.company_document} onChange={set('company_document')} placeholder="00.000.000/0000-00" />
            </div>
            <div className="col-span-2 space-y-2">
              <Label>Seu nome</Label>
              <Input data-testid={AUTH.registerName} required value={form.admin_name} onChange={set('admin_name')} />
            </div>
            <div className="col-span-2 space-y-2">
              <Label>Email</Label>
              <Input data-testid={AUTH.registerEmail} type="email" required value={form.admin_email} onChange={set('admin_email')} />
            </div>
            <div className="col-span-2 space-y-2">
              <Label>Senha (mín. 6)</Label>
              <Input data-testid={AUTH.registerPassword} type="password" required minLength={6} value={form.admin_password} onChange={set('admin_password')} />
            </div>
          </div>
          {error && <div data-testid={AUTH.error} className="text-sm text-rose-500 bg-rose-500/10 border border-rose-500/20 rounded-md px-3 py-2">{error}</div>}
          <Button type="submit" data-testid={AUTH.registerSubmit} disabled={loading} className="w-full h-11 bg-emerald-600 hover:bg-emerald-700 text-white">
            {loading ? 'Criando…' : (<>Criar empresa <ArrowRight className="ml-2 h-4 w-4" /></>)}
          </Button>
          <div className="text-center text-sm text-muted-foreground">
            Já tem conta?{' '}
            <Link data-testid={AUTH.goLogin} to="/login" className="text-emerald-600 dark:text-emerald-400 hover:underline font-medium">Entrar</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
